import { Avatar as AvatarPrimitive } from '@base-ui/react/avatar';

import { cn } from '@/lib/utils';

export type AvatarSize = 'small' | 'medium' | 'large';

export type AvatarProps = AvatarPrimitive.Root.Props & {
  size?: AvatarSize;
};

const Avatar = ({ className, size = 'medium', ...props }: AvatarProps) => {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      data-size={size}
      className={cn(
        'group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full',
        'after:border after:border-gray-400',
        'data-[size=large]:size-10 data-[size=small]:size-6',
        'after:mix-blend-darken dark:after:mix-blend-lighten',
        className,
      )}
      {...props}
    />
  );
};

export default Avatar;
